import styled from 'styled-components'
import { Input as InputAntd } from 'antd'
import { XCircleFill } from '@styled-icons/bootstrap/XCircleFill'
const borderRadius = '5px'

export const Title = styled.div`
  font-size: 12pt;
  font-weight: bold;
  margin-left: 3px;
  margin-bottom: ${(props) => props.$bottom};
`
export const Input = styled.input`
  border-radius: ${borderRadius};
  border-width: 1px;
  border-color: #999999;
  width: 100%;
  font-size: 1rem;
  padding: 7px 11px;

  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
  }
`

export const InputFile = styled(InputAntd)`
 border-radius: ${borderRadius};
  border-width: 1px;
  border-color: #999999;
  width: 100%;
  font-size: 1rem;
  padding: 7px 11px;
`

export const TextArea = styled.textarea`
  border-radius: ${borderRadius};
  border-width: 1px;
  border-color: #999999;
  width: 100%;
  min-height: 120px;
  height: 100%;
  font-size: 10pt;
  margin-bottom: -6px;
  padding: 11px;

  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
  }
`

export const ErrorText = styled.div`
  color: red;
  font-size: 11px;
  margin-left: 3px;
`

export const WrapperInput = styled.div``

export const WrapperProfileImage = styled.div`
  margin-top: 20px;
  border-radiu: 20px;
`
export const ProfileImageLabel = styled.label`
  height: 50px;
  font-size: 1.3em;
  padding: 10px 15px;
  border: 1px solid black;
  border-radius: 4%;
  cursor: pointer;
`
export const WrapperImageInput = styled.div`
  display: flex;
  align-items: center
`

export const WrapperImage = styled.div`
  margin-left: 30px;
  position:relative;
`
export const WrapperImgTag = styled.div`
  border-radius: 50%;
  overflow:hidden;
  border:2px solid black;
  width:150px;
  height:150px;
  img{
    max-height: 150px;
    max-width: 150px;
    pointer-events: none;
  }
`

export const EmptyDiv = styled.div`
  height: 12px;
`
export const Paragraph = styled.p`
  padding: 16px;
`
export const IconWrapper = styled.div`
  height:32px;
  width:32px;
  top:5px;
  right:5px;
  position: absolute;
  border-radius:50%;
  overflow:hidden;
  background-color:black;
  border: 1px solid;
  box-sizing:border-box;
  outline: 1px solid transparent;   
  cursor:pointer;
`
export const TrashIcon = styled(XCircleFill)`
   font-weight: bold;
   fill:white;
`
